module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA1AgMAAACrRoTXAAAACVBMVEX/AAD/////f3/sDLJDAAAAG0lEQVQ4y2NgGAWjAC9YhQUwhGIBo4KjgnAAAA8AufGM9Lq4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/id.png
// module id = vJEz
// module chunks = 2